<template>
  <div class="wave-wrap">
        <div id="bottomLeftChart" style="width:100%;height:88px;"></div>
  </div>
</template>

<script>
// API 调用量声波式波形图（2026-08-21 替换 CPU/内存 1h 趋势）
// 数据源：/live/api/usage?gran=15min&range=24h（node 18903 读 /opt/usage-archive 归档，15 分钟粒度、24h 滚动窗口）
// 样式：声波式密集细条、隐藏网格/刻度，10 秒刷新（与实时余额一致）
const echarts = require("echarts");
export default {
  data() {
    return { chart: null };
  },
  mounted() {
    this.chart = echarts.init(document.getElementById("bottomLeftChart"));
    this.refresh();
    this._timer = setInterval(() => this.refresh(), 10000);
    window.addEventListener("resize", () => this.chart && this.chart.resize(), false);
  },
  beforeDestroy() {
    clearInterval(this._timer);
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },
  methods: {
    async refresh() {
      try {
        const r = await fetch("/live/api/usage?gran=15min&range=24h", { cache: "no-store" });
        if (!r.ok) return;
        const j = await r.json();
        if (!j.buckets || !j.buckets.length) return;
        const bs = j.buckets;
        const fmt = ts => {
          const d = new Date(ts);
          const p = x => (x < 10 ? "0" + x : "" + x);
          return p(d.getMonth() + 1) + "-" + p(d.getDate()) + " " + p(d.getHours()) + ":" + p(d.getMinutes());
        };
        this.chart.setOption(
          {
            animation: false,
            tooltip: {
              trigger: "axis",
              backgroundColor: "rgba(8,12,28,0.92)",
              borderColor: "#2e4a8a",
              textStyle: { color: "#c3cbde", fontSize: 11 },
              axisPointer: { type: "shadow", shadowStyle: { color: "rgba(80,227,194,0.10)" } },
              formatter: ps => {
                if (!ps || !ps.length) return "";
                const p = ps[0];
                const b = bs[p.dataIndex];
                return fmt(b.ts) + "<br/>调用 " + p.value + " 次<br/>token " + (b.tokens || 0);
              }
            },
            grid: { left: 0, right: 0, top: 2, bottom: 0 },
            xAxis: { type: "category", data: bs.map(b => fmt(b.ts)), show: false },
            yAxis: { type: "value", show: false, minInterval: 1 },
            series: [
              {
                name: "调用次数",
                type: "line",
                smooth: true,
                symbol: "none",
                data: bs.map(b => b.count),
                lineStyle: {
                  width: 2,
                  color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                    { offset: 0, color: "#7ef7d4" },
                    { offset: 0.5, color: "#38bdf8" },
                    { offset: 1, color: "#1d4ed8" }
                  ]),
                  shadowBlur: 6,
                  shadowColor: "rgba(56,189,248,0.45)"
                },
                areaStyle: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: "rgba(56,189,248,0.30)" },
                    { offset: 1, color: "rgba(29,78,216,0.03)" }
                  ])
                }
              }
            ]
          },
          true
        );
      } catch (e) {
        console.warn("usage waveform fail:", e.message);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.wave-wrap {
  position: relative;
}
</style>
